import React from 'react'
import BankSlip from '@images/bank_slip_icon.svg'


export default (props) =>
  <img {...props} src={BankSlip}></img>
